export const InboundDbListSeg = 'InboundDbListSeg';
export const ListSegClassic = 'ListSegClassic';
export const CrmSearch = 'CrmSearch';
export const SalesViews = 'SalesViews';
export const ExtensibleReports = 'ExtensibleReports';